var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play",attrs:{"title":_vm.playMsg.title}},[_c('a-player',{ref:"playDom",attrs:{"music":{
    title: _vm.playMsg.productionName,
artist: ' ',
lrc: _vm.playMsg.wordsUrl,
src: _vm.playMsg.sourceUrl,
pic: _vm.playMsg.coverUrl
  }},on:{"pause":function($event){return _vm.pause()},"playing":function($event){return _vm.play()}}}),_vm._v(" "),(_vm.playMsg.isAudit==0)?_c('div',{staticClass:"state"},[_c('img',{attrs:{"src":require("../assets/image/shz.png"),"alt":""}})]):(_vm.playMsg.isAudit==1)?_c('div',{staticClass:"state"},[_c('img',{attrs:{"src":require("../assets/image/tg.png"),"alt":""}})]):_c('div',{staticClass:"state"},[_c('img',{attrs:{"src":require("../assets/image/btg.png"),"alt":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e69c8f7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/play.vue
// module id = null
// module chunks = 